import { changeCart, updatecart } from "../utils/ajax-cart";

class Quantity {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getGoalBar() {
    let element = this.getElement();
    return new GoalBar(element);
  }

  getIncrease() {
    let element = this.getElement();
    return element.querySelectorAll(".js-increase");
  }

  getDecrease() {
    let element = this.getElement();
    return element.querySelectorAll(".js-decrease");
  }

  setDecrease() {
    let decreaseEl = this.getDecrease();

    for (let decrease of decreaseEl) {
      decrease.addEventListener("click", (event) => {
        event.preventDefault();

        let quantityValue = decrease.closest('.js-item').querySelectorAll('.js-value');
        let parentEl = decrease
          .closest(".js-quantity")
          .querySelector(".js-value");
        let minEl = 0;
        let quantityEl = parseInt(parentEl.value);
        let variantId = parentEl.dataset.variant;

        if (minEl < quantityEl) {
          --quantityEl;
          for(let quantityVal of quantityValue) {
            quantityVal.value = quantityEl;
          }

          updatecart({'quantity':quantityEl, 'id':variantId});
        }
      });
    }
  }

  setIncrease() {
    let increaseEl = this.getIncrease();

    for (let increase of increaseEl) {
      increase.addEventListener("click", (event) => {
        event.preventDefault();
        let quantityValue = increase.closest('.js-item').querySelectorAll('.js-value');
        let parentEl = increase.closest(".js-quantity").querySelector(".js-value");
        let quantityEl = parseInt(parentEl.value);
        let variantId = parentEl.dataset.variant;
        ++quantityEl
        for(let quantityVal of quantityValue) {
          quantityVal.value = quantityEl;
        }

        updatecart({'quantity':quantityEl, 'id':variantId});
      });
    }
  }

  setEventHandlers() {
    this.setIncrease();
    this.setDecrease();
  }

  init() {
    this.setEventHandlers();
  }
}


const QuantityInit = {
  init() {
    const $el = document.querySelector(".js-cart");
    if ($el) {
        new Quantity($el);
    }
  },
};


export default QuantityInit;